// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record, List } from "immutable"
import * as R from "ramda"

import { PLACE_MODES, PLACE_VALUE_MODES } from "../consts/place"
import SearchPlace from "./SearchPlace"
import type { Plain } from "./SearchPlace"

type InputObject = {
  places?: List<SearchPlace>
}

type MultiPlain = {
  places?: Plain[]
}

const MultiPlaceRecord = Record({
  places: List(),
})

class MultiPlace extends MultiPlaceRecord {
  constructor(inputObject: InputObject = {}) {
    // let's group places even when opening page with url params
    if (inputObject.places) {
      inputObject.places = R.uniqBy((t) => t.getId(), inputObject.places.toArray())
        // add new and remove all bigger places it is included in
        .reduce(
          // FIXME: a method has been detected that possibly mutates the object, consider a more
          // functional approach (Ramda might help)

          // @ts-expect-error: Flow to TS migration.
          (acc, place) => acc.filter((t) => !place.hasParent(t) && !t.hasParent(place)).push(place),
          // @ts-expect-error: Flow to TS migration.
          new List(),
        )
    }
    super(inputObject)
  }

  isDefault(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.places.size === 1 && this.places.first() && this.places.first().isDefault
  }

  getType(): string {
    // @ts-expect-error: Flow to TS migration.
    if (this.places.size > 1) {
      return "multiPlace"
    }

    // @ts-expect-error: Flow to TS migration.
    if (this.places.size === 1 && this.places.first()) {
      // @ts-expect-error: Flow to TS migration.
      return this.places.first().getType()
    }

    return "place"
  }

  getId(): string {
    // @ts-expect-error: Flow to TS migration.
    if (this.places.size > 1) {
      return "multiPlace"
    }

    // @ts-expect-error: Flow to TS migration.
    if (this.places.size === 1 && this.places.first()) {
      // @ts-expect-error: Flow to TS migration.
      return this.places.first().getId()
    }

    return "-"
  }

  getSearchId(): string | null | undefined {
    // @ts-expect-error: Flow to TS migration.
    if (this.places.size > 0) {
      // @ts-expect-error: Flow to TS migration.
      if (this.places.some((place) => place.getId() === PLACE_MODES.ANYWHERE)) {
        return PLACE_MODES.ANYWHERE
      }
      // @ts-expect-error: Flow to TS migration.
      return this.places.map((place) => place.getSearchId()).join(",")
    }
    return PLACE_MODES.ANYWHERE
  }

  getMode(): string | null | undefined {
    // @ts-expect-error: Flow to TS migration.
    if (this.places.size > 0) {
      // @ts-expect-error: Flow to TS migration.
      if (this.places.size === 1 && this.places.first()) {
        // @ts-expect-error: Flow to TS migration.
        return this.places.first().mode
      }
      return PLACE_VALUE_MODES.MULTI_PLACE
    }
    return PLACE_VALUE_MODES.UNSELECTED
  }

  isLarge(): boolean {
    // @ts-expect-error: Flow to TS migration.
    if (this.places.size === 0) {
      return false
    }
    // @ts-expect-error: Flow to TS migration.
    return this.places.some((place) => place.isLarge())
  }

  isEmpty(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.places.isEmpty()
  }

  isAnywhere(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.places.size === 1 && this.places.first().isAnywhere()
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static fromPlainJS(plain: MultiPlain): MultiPlace {
    return new MultiPlace({
      places: plain.places
        ? List(plain.places.map((plainPlace) => SearchPlace.fromPlainJS(plainPlace)))
        : List(),
    })
  }

  getGeo() {
    // @ts-expect-error: Flow to TS migration.
    return this.places.size === 1 ? this.places.get(0).getGeo() : null
  }

  contains(place: SearchPlace) {
    // @ts-expect-error: Flow to TS migration.
    return this.places.some((p) => p.equals(place))
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static anywhere() {
    return new MultiPlace({ places: List([new SearchPlace({ mode: "anywhere" })]) })
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static empty() {
    return new MultiPlace({ places: List() })
  }
}

export default MultiPlace
